import React from 'react';
import { createRoot } from 'react-dom/client';
import './assets/css/index.scss';
import './assets/css/fonts.scss';
import RootScreen from './screens/RootScreen/RootScreen';
import { BrowserRouter } from 'react-router-dom';
import ChakraContext from './context/ChakraContext';
import { MapContextProvider } from './context/MapContext';
import { UIContextProvider } from './context/UIContext';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <BrowserRouter>
        <ChakraContext>
            <UIContextProvider>
                <MapContextProvider>
                        <RootScreen />
                </MapContextProvider>
            </UIContextProvider>
        </ChakraContext>
    </BrowserRouter>
);
